import { StockInStoreDetail } from './stock-in-store-detail.component';

export default StockInStoreDetail;
